import React from 'react';
import { useTranslation } from 'react-i18next';

const CTABanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 bg-accent-gradient relative animate-on-scroll" aria-labelledby="cta-title">
      <div className="container-custom text-center">
        <h2 id="cta-title" className="text-3xl md:text-4xl font-bold mb-6 text-bg-primary">
          {t('ctaBanner.heading')}
        </h2>
        
        <a 
          href="#copytrading" 
          className="btn bg-bg-primary text-text-light hover:bg-bg-primary/90"
          role="button"
          aria-label={t('ctaBanner.cta')}
        >
          {t('ctaBanner.cta')}
        </a>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" aria-hidden="true">
        <div className="absolute -top-12 -right-12 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-12 -left-12 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
      </div>
    </section>
  );
};

export default CTABanner;